var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00033 10.668L4.66699 7.33464L5.60033 6.36797L7.33366 8.1013V2.66797H8.66699V8.1013L10.4003 6.36797L11.3337 7.33464L8.00033 10.668ZM4.00033 13.3346C3.63366 13.3346 3.31988 13.2042 3.05899 12.9433C2.7981 12.6824 2.66744 12.3684 2.66699 12.0013V10.0013H4.00033V12.0013H12.0003V10.0013H13.3337V12.0013C13.3337 12.368 13.2032 12.682 12.9423 12.9433C12.6814 13.2046 12.3674 13.3351 12.0003 13.3346H4.00033Z",
    fill: "#7BC1FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.c9c5bae7fa9da23a4789baa43d9069dc.svg";
export { ForwardRef as ReactComponent };